import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { ChannelService } from '@app/core/channels/services/channel.service';

@Component({
  selector: 'cnc-channel-hubspot-sync-popup',
  templateUrl: './channel-hubspot-sync-popup.component.html',
  styleUrls: ['./channel-hubspot-sync-popup.component.scss'],
})
export class ChannelHubSpotPopupComponent implements OnInit {
  formData :UntypedFormGroup;
  loading :boolean;
  submitted :boolean;

  @Input() channel :any;

  constructor(
    private fb :UntypedFormBuilder,
    public activeModal :NgbActiveModal,
    public channelSvc :ChannelService,
    private toastr :ToastrService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      create_missing: [false],
    });
  }

  save() {
    this.submitted = true;
    if (this.formData.invalid) {
      Swal.fire({
        title: 'Form Error!',
        text: 'Please fill all the required fields.',
        type: 'error',
        confirmButtonText: 'Back to Form',
      });

      return;
    }

    this.loading = true;

    const newFormData = new FormData();
    newFormData.append(
      'create_missing',
      this.formData.controls['create_missing'].value ? '1' : '0',
    );

    this.channelSvc.syncHubSpotData(this.channel.id, newFormData).subscribe(
      (resp) => {
        this.toastr.success('HubSpot data synced.');
        this.loading = false;
        this.activeModal.dismiss();
      },
      (error) => {
        const errors = error.error;
        for (const [error_key, error] of Object.entries(errors)) {
          for (const [message_key, message] of Object.entries(error)) {
            this.toastr.error(message);
          }
        }
        this.loading = false;
        this.cd.detectChanges();
      },
    );
  }
}
